/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q5Inputs */

const en_pc_faq_q5 = /** @type {(inputs: Pc_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does PdfCraft Online upload my files?`)
};

const zh_pc_faq_q5 = /** @type {(inputs: Pc_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版会上传我的文件吗？`)
};

/**
* | output |
* | --- |
* | "Does PdfCraft Online upload my files?" |
*
* @param {Pc_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q5 = /** @type {((inputs?: Pc_Faq_Q5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q5(inputs)
	return zh_pc_faq_q5(inputs)
});
export { pc_faq_q5 as "pc.faq.q5" }